module.exports = __webpack_public_path__ + "img/dev3.79e0a360.jpg";